<template>
    <div class="attachment-item">
        <!-- Resim dosyaları için önizleme göster -->
        <div v-if="isImage" class="image-preview" @click="openAttachment">
            <img :src="getAttachmentUrl()" alt="Görsel önizleme" />
        </div>
        <div class="attachment-info" @click="openAttachment">
            <div class="attachment-icon" v-if="!isImage">
                <i class="material-icons">{{ getAttachmentIcon() }}</i>
            </div>
            <div class="attachment-details">
                <div class="attachment-name">{{ attachment.name || "unnamed" }}</div>
                <div class="attachment-size">{{ formatFileSize }}</div>
            </div>
        </div>
        <div class="attachment-actions">
            <a :href="getAttachmentUrl()" :download="attachment.name || 'unnamed'" target="_blank" @click.stop>
                <a-button type="link" size="small">
                    <i class="material-icons" style="font-size: 18px;">download</i>
                </a-button>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "AttachmentItem",
    props: {
        attachment: {
            type: Object,
            required: true
        }
    },
    computed: {
        isImage() {
            return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(this.attachment.ext);
        },
        formatFileSize() {
            const bytes = this.attachment.size;
            if (!bytes || isNaN(bytes)) return '0 KB';
            
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes === 0) return '0 KB';
            
            const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
            if (i === 0) return `${bytes} ${sizes[i]}`;
            
            return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
        }
    },
    methods: {
        getAttachmentIcon() {
            switch (this.attachment.ext) {
                case 'pdf':
                    return 'picture_as_pdf';
                case 'doc':
                case 'docx':
                    return 'description';
                case 'xls':
                case 'xlsx':
                    return 'table_chart';
                case 'ppt':
                case 'pptx':
                    return 'slideshow';
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'gif':
                case 'bmp':
                case 'webp':
                    return 'image';
                case 'zip':
                case 'rar':
                    return 'folder_zip';
                default:
                    return 'attach_file';
            }
        },
        
        getAttachmentUrl() {
            return this.attachment.v2Format && this.attachment.cdnUrl
                ? this.attachment.cdnUrl
                : this.attachment.cdnUrl || `https://static.supsis.live/${this.attachment.path}${this.attachment._id}.${this.attachment.ext}`;
        },
        
        openAttachment() {
            const url = this.getAttachmentUrl();
            if (url) {
                window.open(url, '_blank');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.attachment-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f9f9f9;
    border-radius: 4px;
    border: 1px solid #eaeaea;
    padding: 8px 12px;
    width: 100%;
    margin-bottom: 8px;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
        background-color: #f0f0f0;
        border-color: #ddd;
    }

    &:last-child {
        margin-bottom: 0;
    }

    .image-preview {
        width: 50px;
        height: 50px;
        margin-right: 12px;
        border-radius: 3px;
        overflow: hidden;
        flex-shrink: 0;
        
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .attachment-info {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;

        .attachment-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;

            i {
                font-size: 24px;
                color: #555;
            }
        }

        .attachment-details {
            min-width: 0;
            
            .attachment-name {
                font-size: 13px;
                font-weight: 500;
                color: #333;
                margin-bottom: 2px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 100%;
            }

            .attachment-size {
                font-size: 12px;
                color: #888;
            }
        }
    }

    .attachment-actions {
        margin-left: 8px;
        flex-shrink: 0;
    }
}
</style> 